import { postData } from '../utils/ajax-utils';

type FaqSearchAutocompleteType = {
    ajaxController: AbortController|null,
    $listContainer: HTMLElement|null,
    $faqAutocomplete: HTMLElement|null,
    init(): void,
    initFaqSearchAutocomplete(): void,
    clearList(): void,
    hideList(): void,
    showList(): void,
    getErrorMessage(): string,
};

const FaqSearchAutocomplete: FaqSearchAutocompleteType = {
    ajaxController: null,
    $listContainer: null,
    $faqAutocomplete: null,

    init() : void {
        this.$faqAutocomplete = document.querySelector<HTMLElement>('.js-faq-search-autocomplete');
        
        if (this.$faqAutocomplete) {
            this.initFaqSearchAutocomplete();
        }
    },

    /**
     * @return {void}
     */
    initFaqSearchAutocomplete() : void {
        const $inp = this.$faqAutocomplete?.querySelector<HTMLInputElement>('.js-search-faq-input');
        this.$listContainer = this.$faqAutocomplete?.querySelector<HTMLElement>('.js-faq-autocomplete-list') || null;
        const $loading = this.$faqAutocomplete?.querySelector<HTMLElement>('.loading');

        // Close all list when click on the document
        document.addEventListener('click', e => {
            if ((e.target as HTMLElement).closest('.js-search-faq-input')) {
                this.showList();
            } else {
                this.hideList();
            }
        });

        document.addEventListener('keydown', e => {
            if ('Escape' === e.key) {
                this.hideList();
            }
        });

        // Execute a function when someone writes in the text field
        $inp?.addEventListener('input', e => {
            this.clearList();

            const val = (e.target as HTMLInputElement).value;

            if (!val || val.length < 3) {
                return;
            }

            $loading?.classList.remove('hidden');

            // Abort previous request
            if (this.ajaxController) {
                this.ajaxController.abort();
            }

            this.ajaxController = new AbortController();
            const ajaxArgs = {
                action: 'search_faq_page',
                search: val,
            };
            postData(scriptVar.ajaxUrl, ajaxArgs, this.ajaxController.signal).then(response => {
                if (response.success) {
                    let list = '';
                    response.data.forEach((page: { title: string, url: string }) => {
                        list += `<div class="autocomplete-item"><strong><a href="${page.url}">${page.title}</a></strong></div>`;
                    });

                    if (this.$listContainer) {
                        this.$listContainer.innerHTML = list;
                    }
                } else if (this.$listContainer) { // No results
                    this.$listContainer.innerHTML = this.getErrorMessage();
                }

                $loading?.classList.add('hidden');

                this.showList();
            }).catch(error => {
                console.error('Error:', error);

                $loading?.classList.add('hidden');

                if (this.$listContainer) {
                    this.$listContainer.innerHTML = this.getErrorMessage();
                }

                this.showList();
            });
        });
    },

    /**
     * @return {void}
     */
    clearList() : void {
        if (this.$listContainer) {
            this.$listContainer.innerHTML = '';
        }
    },

    /**
     * @return {void}
     */
    hideList() : void {
        this.$listContainer?.classList.add('hidden');
    },

    /**
     * @return {void}
     */
    showList() : void {
        this.$listContainer?.classList.remove('hidden');
    },

    /**
     * Get the message for no result found in .js-faq-search-autocomplete attr data-error-msg
     * 
     * @return {string}
     */
    getErrorMessage() : string {
        const errorMsg = this.$faqAutocomplete?.dataset.errorMsg as string;
        return '<p>' + errorMsg + '</p>';
    },
};

export default FaqSearchAutocomplete;
